import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const slideshowRow = () => {
	const elements = document.querySelectorAll('.row--slideshow');
	if (!elements) return;

	elements.forEach((element) => {
		const swiperElement = element.querySelector('.swiper');
		if (swiperElement) {
			const swiperPagination = element.querySelector('.row__slides__pagination');
			const swiperPrev = element.querySelector('.row__slides__prev');
			const swiperNext = element.querySelector('.row__slides__next');
			const autoscroll = swiperElement.classList.contains('autoscroll');

			const swiper = new Swiper(swiperElement, {
				modules: [Navigation, Pagination],
				spaceBetween: 20,
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide',
				},
				autoplay: autoscroll,
				navigation: {
					nextEl: swiperNext,
					prevEl: swiperPrev,
				},
				pagination: {
					el: swiperPagination,
					type: 'bullets',
					clickable: true,
				},
			})
		}
	});
};

export default slideshowRow;
